import styled from 'styled-components';
import { spacing, fontWeights, fontSizes, colors, subtitle2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Badge } from 'ui/badge';
import { SecondaryButton } from 'ui/button';
import { SelectWrapper } from 'ui/selects';

export const QueryBuilderText = styled.div`
  white-space: nowrap;
  display: flex;
  justify-content: flex-start;
  font-size: ${fontSizes.s14};
  font-weight: ${fontWeights.semiBold};
  line-height: ${fontSizes.s14};
  margin-top: ${spacing.half};
  min-height: ${spacing.plusHalf};
  align-items: center;
  padding-right: ${spacing.plusHalf};
  width: ${pxToRem(180)};
`;

export const UpdatedStyledConditionBadge = styled(Badge)`
  width: ${pxToRem(45)};
  min-width: ${pxToRem(45)};
`;

export const UpdatedQueryBuilderBadgeWrapper = styled.div`
  padding-left: ${spacing.plusThreeQuarter};
`;

export const UpdatedQueryBuilderText = styled.div`
  ${subtitle2}
  white-space: nowrap;
  display: flex;
  justify-content: flex-start;
  color: ${colors.textPrimary};
  margin-top: ${spacing.half};
  min-height: ${spacing.plusHalf};
  align-items: center;
  padding-right: ${spacing.half};
  width: ${pxToRem(180)};
`;

export const UpdatedQueryBuilderLeadText = styled(UpdatedQueryBuilderText)`
  padding-left: ${pxToRem(60)};
  padding-right: ${spacing.half};
`;

export const QueryBuilderFollowingText = styled(QueryBuilderText)`
  display: flex;
  align-items: center;
  gap: ${spacing.plusHalf};
  min-height: ${spacing.plusHalf};
`;

export const UpdatedQueryBuilderFollowingText = styled(UpdatedQueryBuilderText)`
  display: flex;
  align-items: center;
  gap: ${spacing.base};
  min-height: ${spacing.plusHalf};
  padding-right: ${spacing.half};
  min-width: ${pxToRem(80)};
`;

export const StyledPurpleSecondaryButton = styled(SecondaryButton)`
  && {
    &[data-empty='true'] {
      background: ${colors.white};
      border-color: ${colors.grey25};
      box-shadow: none;
      border-style: dashed;
      color: ${colors.secondaryText};
      padding: ${spacing.threeEights} ${spacing.fiveEights};
      :hover {
        border-color: ${colors.grey50};
        color: ${colors.purple100};
      }
      :active {
        transform: none;
        box-shadow: none;
      }
    }
    &[data-empty='true'][data-open='true'] {
      background-color: ${colors.purple10};
      color: ${colors.purple100};
      border: 1px dashed ${colors.purple50};
    }
    &[data-filled='true'] {
      background-color: ${colors.purple10};
      color: ${colors.purple70};
      border: 1px solid transparent;
      box-shadow: none;
      :hover {
        border: 1px solid ${colors.purple50};
        box-shadow: 0 0 0 ${spacing.single} transparent;
        color: ${colors.purple100};
      }
    }
    &[data-filled='true'][data-open='true'] {
      color: ${colors.purple100};
      border: 1px solid ${colors.purple50};
      box-shadow: 0 0 0 ${spacing.single} ${colors.purple50};
    }
  }
`;
export const StyledPurpleSelectWrapper = styled(SelectWrapper)`
  border: none;
  box-shadow: none;
  color: ${colors.purple90};
`;
